import { useEffect, useState } from 'react';

import { useCatalogRouteMatch } from '@utils/common';
import { useIndexedFilters } from '@hook/productFilters';
import { SeoHubBlockTypeEnum } from '@v5Models';
import { SeoHubItems } from '@components/SeoHub';
import {
  useSeoHubCatalogQuery,
  useThematicsFiltersQuery,
} from '@containers/SeoHubCatalog/gql/graphql.v5.generated';

export const useSeoHubData = () => {
  const { params } = useCatalogRouteMatch()!;
  const { hasFilters: hasIndexedFilters } = useIndexedFilters();
  const slug = 'slug' in params ? params.slug : params.namespace;

  const { data: seoHubData, loading: seoHubLoading } = useSeoHubCatalogQuery({
    variables: { slug },
    context: {
      v5: true,
      batch: true,
    },
    skip: hasIndexedFilters,
  });

  const {
    data: thematicsFiltersData,
    loading: thematicsFiltersLoading,
  } = useThematicsFiltersQuery({
    variables: { slug },
    context: {
      v5: true,
      batch: true,
    },
  });

  const [isLoaded, setIsLoaded] = useState(!seoHubLoading && !thematicsFiltersLoading);
  useEffect(() => {
    if (!seoHubLoading && !thematicsFiltersLoading) {
      setIsLoaded(true);
    }
  }, [seoHubLoading, thematicsFiltersLoading]);

  const seoHubItems = seoHubData?.seoHubByCatalog.reduce(
    (acc, item) => {
      acc[item.blockType] = item.items;
      return acc;
    },
    {} as Record<SeoHubBlockTypeEnum, SeoHubItems[]>,
  );

  return {
    filterThematics: thematicsFiltersData?.filterThematics,
    seoHubItems: seoHubItems,
    loaded: isLoaded,
  };
};